/**
 * CTA Buttons Script
 * Voegt interactieve effecten toe aan CTA knoppen
 */

document.addEventListener('DOMContentLoaded', function() {
  // Initialiseer alle CTA knoppen
  initCTAButtons();
  
  // Observer voor dynamisch toegevoegde knoppen
  setupMutationObserver();
});

/**
 * Initialiseer de CTA knoppen met events
 */
function initCTAButtons() {
  // Verzamel alle CTA knoppen
  const ctaButtons = document.querySelectorAll('.cta-button');
  
  ctaButtons.forEach(button => {
    // Verwijder eventuele dubbele event listeners
    button.removeEventListener('click', handleRippleEffect);
    // Voeg ripple effect toe bij klik
    button.addEventListener('click', handleRippleEffect);
  });
  
  console.log(`${ctaButtons.length} CTA knoppen geïnitialiseerd`);
}

/**
 * Creëer ripple effect bij klikken op knop
 */
function handleRippleEffect(event) {
  const button = this;
  
  // Verwijder bestaande ripple elementen
  const existingRipples = button.querySelectorAll('.ripple');
  existingRipples.forEach(ripple => ripple.remove());
  
  // Maak nieuw ripple element
  const ripple = document.createElement('span');
  ripple.classList.add('ripple');
  
  // Positioneren van de ripple op klikpositie
  const rect = button.getBoundingClientRect();
  const size = Math.max(rect.width, rect.height);
  
  ripple.style.width = ripple.style.height = `${size}px`;
  ripple.style.left = `${event.clientX - rect.left - size / 2}px`;
  ripple.style.top = `${event.clientY - rect.top - size / 2}px`;
  
  // Voeg toe aan de knop
  button.appendChild(ripple);
  
  // Verwijder ripple na animatie
  setTimeout(() => {
    ripple.remove();
  }, 800);
}

/**
 * Observer voor dynamisch toegevoegde knoppen
 */
function setupMutationObserver() {
  // Observer configuratie
  const config = { childList: true, subtree: true };
  
  // Callback functie
  const mutationCallback = (mutationsList) => {
    let hasNewButtons = false;
    
    for (const mutation of mutationsList) {
      if (mutation.type === 'childList' && mutation.addedNodes.length) {
        // Zoek naar nieuwe CTA knoppen in toegevoegde nodes
        for (const node of mutation.addedNodes) {
          if (node.nodeType === Node.ELEMENT_NODE) {
            // Kijk of het element zelf een cta-button is
            if (node.classList && node.classList.contains('cta-button')) {
              hasNewButtons = true;
              break;
            }
            
            // Kijk of het element geneste cta-buttons bevat
            if (node.querySelectorAll && node.querySelectorAll('.cta-button').length > 0) {
              hasNewButtons = true;
              break;
            }
          }
        }
      }
      
      if (hasNewButtons) break;
    }
    
    // Als er nieuwe knoppen zijn gevonden, initialiseer ze
    if (hasNewButtons) {
      console.log('Nieuwe CTA knoppen gedetecteerd, opnieuw initialiseren');
      initCTAButtons();
    }
  };
  
  // Observer aanmaken en starten
  const observer = new MutationObserver(mutationCallback);
  observer.observe(document.body, config);
} 